import { FiChevronRight } from "react-icons/fi";

export function renderreport () {
    return (
  <div className="transition-opacity duration-300">

    {/* Breadcrumbs */}
    <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
      <a className="hover:text-primary hover:underline" href="#">Netraa APM</a>
      <FiChevronRight className="text-[14px]" />
      <span>Product Capabilities</span>
      <FiChevronRight className="text-[14px]" />
      <span className="text-[#1b140d] dark:text-white font-medium">Reports</span>
    </nav>

    {/* Page Heading */}
    <div className="mb-12">
      <h1 className="text-4xl lg:text-5xl font-black text-[#1b140d] dark:text-white mb-6 leading-tight tracking-tight">
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
          Reports:
        </span> Structured Observability Insights
      </h1>
      <p className="text-lg text-[#9a734c] dark:text-[#cbb094] leading-relaxed">
        Reporting in Netraa APM transforms raw observability data into structured, consumable insights.
        Designed for both technical leads and executive stakeholders, reports provide the historical
        context needed to make informed operational decisions.
      </p>
    </div>
    {/* SECTION 2 */}
    <section className="mb-16 scroll-mt-24" id="html-reports">
      <h2 className="text-2xl font-bold mb-4 border-l-4 border-primary pl-4">
        HTML Reports
      </h2>

      <p className="mb-8 opacity-90">
        Portable and shareable observability artifacts that preserve the context of an incident or
        a performance milestone. HTML reports are standalone documents that include interactive
        charts, executive summaries, and deep-link breadcrumbs back to the Netraa Platform.
      </p>

      <div className="bg-white dark:bg-[#2d2218] border border-primary/20 rounded-xl shadow-xl">
        <div className="px-6 py-4 flex justify-between items-center border-b">
          <div className="flex items-center gap-3">
            <div className="size-6 bg-primary rounded flex items-center justify-center text-white text-[10px] font-bold">
              N
            </div>
            <span className="font-bold text-sm">
              HTML Report Preview - Q4 Infrastructure
            </span>
          </div>
          <button className="bg-primary text-white text-xs font-bold px-4 py-2 rounded-lg flex items-center gap-2">
            <span className="material-symbols-outlined text-sm"></span>
            Download Report
          </button>
        </div>

        <div className="p-8 space-y-6">
          <h3 className="text-xl font-bold">Executive Performance Summary</h3>
          <p className="text-xs opacity-70">
            Generated on Oct 12, 2023 • Coverage: All Microservices
          </p>

          <div className="p-4 rounded-lg border-l-4 border-primary">
            <h4 className="text-sm font-bold mb-2">Key Observation</h4>
            <p className="text-xs italic">
              "The deployment on Oct 10th showed a 12% reduction in p99 latency
              for the checkout service, correlating with the database indexing updates."
            </p>
          </div>
        </div>
      </div>
    </section>
    {/* SECTION 1 */}
    {/* <section className="mb-16" id="performance-reports">
      <h2 className="text-2xl font-bold mb-4 border-l-4 border-primary pl-4">
        Performance Reports
      </h2>

      <p className="mb-8 opacity-90">
        Gain high-level visibility into your application's health over extended durations.
        Performance reports aggregate metrics across services to identify trends that might
        be missed in real-time monitoring. Schedule these reports to be delivered directly to
        your engineering team's inbox for weekly retrospectives.
      </p>

      <div className="bg-white dark:bg-[#2d2218] border rounded-xl shadow-sm p-6 mb-8">
        <div className="flex items-center gap-3 mb-6">
          <span className="material-symbols-outlined text-primary">
            .
          </span>
          <span className="font-bold text-sm uppercase">
            Scheduled Report Configuration
          </span>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <label className="block">
              <span className="text-sm font-semibold block mb-1">
                Frequency &amp; Format
              </span>
              <select className="w-full rounded-lg border text-sm">
                <option>Daily PDF Summary</option>
                <option>Weekly PDF Detailed</option>
                <option>Monthly HTML Archive</option>
              </select>
            </label>

            <label className="block">
              <span className="text-sm font-semibold block mb-1">Recipients</span>
              <div className="border rounded-lg p-2 flex flex-wrap gap-2 min-h-[38px]">
                <span className="bg-primary/20 text-primary text-xs font-bold px-2 py-1 rounded">
                  DevOps Team
                </span>
                <span className="bg-primary/20 text-primary text-xs font-bold px-2 py-1 rounded">
                  SRE Leads
                </span>
              </div>
            </label>
          </div>

          <div className="space-y-2">
            <span className="text-sm font-semibold block mb-1">
              Metric Selection
            </span>
            <div className="flex justify-between p-2 border rounded">
              <span>P99 Latency</span>
              <span className="material-symbols-outlined text-primary">.</span>
            </div>
            <div className="flex justify-between p-2 border rounded">
              <span>Request Throughput</span>
              <span className="material-symbols-outlined text-primary">.</span>
            </div>
            <div className="flex justify-between p-2 border rounded border-primary/30">
              <span>Error Rate (5xx)</span>
              <span className="material-symbols-outlined text-primary">.</span>
            </div>
          </div>
        </div>
      </div>
    </section> */}

    {/* SECTION 3 */}
    <section className="mb-16 scroll-mt-24" id="observability-loop">
      <h2 className="text-2xl font-bold mb-4 border-l-4 border-primary pl-4">
        Closing the Observability Loop
      </h2>

      <p className="opacity-90">
        Alerting tells you something is wrong right now; Reporting tells you why it keeps happening.
        By integrating Alerting data into your weekly reports, Netraa APM closes the operational loop.
        Proactive operations rely on this synergy to move from reactive fire-fighting to continuous
        performance optimization.
      </p>
    </section>

  </div>
);
}